import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from 'react-i18next';

type Props = {
  show: boolean;
  handleClose: () => void;
};

export const NLMOverrideErrorModal = ({
  show,
  handleClose
}: Props) => {
  const { t } = useTranslation();
  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName="override-error-modal__dialog"
      contentClassName="override-error-modal__content"
      className="override-error-modal"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Body className="override-error-modal__body">
        <h2 className="heading-xxl override-error-modal__title">
          {t("nlmsettings.validation_header")}
        </h2>
        <p className="lead">{t("nlmsettings.validation_subheader")}</p>
        <button
          className="DNA-button"
          onClick={handleClose}
        >
          {t("nlmsettings.Validation_button_text")}
        </button>
      </Modal.Body>
    </Modal>
  );
};
